import React from 'react';
import { Popup, Navbar, Page, Block, Button } from 'framework7-react';
import PropTypes from 'prop-types';
import II18 from '../../translate/II18';
import { gae } from '../../helpers/Analytics';

export const ConfirmCollectBioData = props => {
  const { opened, onCancel, onConfirm } = props;

  return (
    <Popup
      id="confirmCollectBioDataPopUp"
      className="confirmCollectBioDataPopUp"
      opened={Boolean(opened)}
      swipeToClose={false}
      closeByOutsideClick={false}
      closeByBackdropClick={false}
      onPopupOpen={() => gae('CONFIRM_BIODATA_POP_UP', 'SHOW')}
      style={{ height: 'auto', minWidth: 700 }}
    >
      <Page style={{ background: '#fff', position: 'relative' }}>
        <Navbar title={II18.get('confirm_bio_data_collecting_title')}></Navbar>
        <Block>{II18.get('confirm_bio_data_collecting_message')}</Block>
        <div
          style={{
            bottom: '0',
            height: 50,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'end',
            width: 'calc(100% - 20px)',
            padding: '0 10px'
          }}
        >
          <Button id={'confirmBioCancel'} onClick={() => onCancel()}>
            <II18>title_cancel</II18>
          </Button>
          <Button fill id={'confirmBioAccept'} onClick={() => onConfirm()}>
            <II18>confirm_bio_data_collecting_confirm</II18>
          </Button>
        </div>
      </Page>
    </Popup>
  );
};

ConfirmCollectBioData.propTypes = {
  opened: PropTypes.any,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func
};
